/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getSeparatorClassName } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';

import cardTitleTemplate from 'app/scripts/views/templates/card_title_on_card_front';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { QuickCardEditorView } from 'app/scripts/views/card/QuickCardEditorView';
import { Analytics } from '@trello/atlassian-analytics';

const renderName = function () {
  const data = this.model.toJSON();

  data.separatorClassName = getSeparatorClassName(data.name);

  const html = cardTitleTemplate(data);

  $('.js-card-name', this.$el).html(html);

  return this;
};

const openQuickCardEditor = function (e) {
  if (this.options.quickEditHidden || !this.model.editable()) {
    return;
  }

  stopPropagationAndPreventDefault(e);
  PopOver.hide();
  QuickCardEditorView.open(this);
  Analytics.sendClickedButtonEvent({
    buttonName: 'quickCardEditorButton',
    source: 'cardView',
    containers: this.model?.getAnalyticsContainers(),
  });

  return this;
};

export { renderName };
export { openQuickCardEditor };
